//
// Represents a throbber image.  Animated GIFs just stop
// in IE when the page is directed somewhere else.  So, the throbber
// gif wouldn't move in IE for our SystemStatus messages.  This javascript
// moves the gif frames manually
//
//  Ben Ramey
//  September 2010
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.Throbber = function (imageTag)
{
  this.imagesPath = HEIJS.context.getResourceUri("/resources/images/throbber/");
  this.imageTag = imageTag;

  this.preloadImages();
};

HEIJS.Controls.Throbber.prototype =
{
  //
  // Properties
  //
  numFrames: 12,
  frameCounter: 0,
  imagesPath: null,
  imageTag: null,
  imageFrames: [],
  interval: null,

  //
  // Methods
  //
  preloadImages: function ()
  {
    for (var i = 1; i <= 12; i++)
    {
      var img = new Image();
      img.src = this.imagesPath + i + ".gif";
      this.imageFrames.push(img);
    }
  },

  start: function ()
  {
	if (this.interval != null)
	{
		return;
    }
	var self = this;
    this.interval = setInterval(function () { self.doAnimation() }, 100);
  },

  stop: function ()
  {
    clearInterval(this.interval);
    this.interval = null;
  },

  doAnimation: function ()
  {
    if (this.frameCounter == this.numFrames)
    {
      this.frameCounter = 0;
      // prevents the animation from going on forever when
      // the image has been hidden or removed, but "stop" has not been
      // officially called
      if (!this.imageTag.is(":visible"))
      {
        this.stop();
        return;
      }
    }

    this.imageTag.attr("src", this.imageFrames[this.frameCounter % this.numFrames].src);
    this.frameCounter++;
  }
};